import { Component, OnInit, Input } from '@angular/core';
import { SessionService } from '../common/session/session.service';
import { UtilsService } from '../utils/utils.service';
import { DetailsService } from '../details/details.service';
import { AnalyticsService } from '../analytics/analytics.service';

@Component({
  selector: 'social-networks-share',
  templateUrl: './social-networks-share.component.html',
  styleUrls: ['./social-networks-share.component.scss']
})
export class SocialNetworksShareComponent implements OnInit {
  eventData:any = {};
  @Input()
  parent:any={};
  @Input()
  socialNetworks:Array<any> = [];
  @Input()
  isHome:boolean=false;
  @Input()
  listView:string="grid";

  isShareModalDisplayed:any=false;
  social:any;

  constructor(public sessionService:SessionService, private utilsService:UtilsService, public detailsService:DetailsService,
    private analyticsService: AnalyticsService) {
  }

  toggleShareModal() {
    this.isShareModalDisplayed=!this.isShareModalDisplayed;
  }

  getUrl():string {
    if(this.parent.entityId || this.parent.idProduct || this.parent.id) {
      const productId = this.parent.entityId || this.parent.idProduct || this.parent.id;
      //return `${document.location.protocol}//${document.location.host}/${this.eventData.eventName}/product/${productId}/detail`;
    }
    if(this.parent.entityId || this.parent.idExhibitor || this.parent.id) {
      const exhibitorId = this.parent.entityId || this.parent.idExhibitor || this.parent.id;
      //return `${document.location.protocol}//${document.location.host}/${this.eventData.eventName}/exhibitor/${exhibitorId}/detail`;
    }
    return document.location.href;
  }

  getTags() {
    return this.eventData.hashtags;
  }

  obtainDescription() {
    if(this.parent.translations || this.parent.productTranslation) {
      const prodTr = this.parent.translations || this.parent.productTranslation;
      return `${''} ${this.utilsService._api(prodTr, 'description')}`;
    }
    if(this.parent.translations || this.parent.exhibitorDescription) {
      const exTr = this.parent.translations || this.parent.exhibitorDescription;
      return `${''} ${this.utilsService._api(exTr, 'description')}`;
    }
    return "";
  }

  sendShareDatalayerEvent(method:string):void {
    const exhibitorId = this.parent.id;
    if(!!exhibitorId) {
      this.analyticsService.sendShare("Exhibitor", exhibitorId, method);
    }
    const productId = this.parent.productId;
    if(!!productId) {
      this.analyticsService.sendShare("Product", productId, method);
    }
  }

  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
  }
}
